import "./modal.scss";
import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import { Modal as ModalShared } from "@src/shared/src";

interface IModalButton {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  action: () => void;
  theme?: string;
}
interface IModal {
  modalId?: string;
  isShow: boolean;
  title?: string;
  overlay?: boolean;
  overlayValue?: number;
  overlayStyle?: React.CSSProperties;
  theme?: "brown500";
  text?: string;
  buttons?: IModalButton[];
  onClose?: () => void;
  zIndex?: number;
}
const Modal = ({
  modalId,
  isShow,
  overlay = false,
  overlayValue = 0.08,
  overlayStyle,
  theme,
  title,
  text,
  buttons,
  onClose,
  zIndex,
}: IModal) => {
  // const uuid = uuidv4();
  // return (
  //   <div className="modal-wrap" style={{ display: isShow ? "block" : "none" }}>
  //     {overlay && (
  //       <div
  //         className="modal-overlay"
  //         style={{ backgroundColor: `rgba(0, 0, 0, ${overlayValue})`, ...overlayStyle }}
  //       ></div>
  //     )}
  //     <div className="modal">
  //       <div className={`modal-content-box ${title && text ? "exists-title-and-text" : ""}`}>
  //         <h2 className="modal-title">{title}</h2>
  //         <p className="modal-text">{text}</p>
  //       </div>

  //       {buttons ? (
  //         <div
  //           className={`modal-btn-wrap ${buttons.length === 1 ? "" : "btn-wrap"} btn-wrap-no-padding ${buttons.length >= 2 ? "btn-wrap-columns-1-1" : ""}`}
  //         >
  //           {buttons.map((button) => (
  //             <div key={`${modalId ? modalId : uuid}-${button.name}`}>
  //               <button
  //                 style={button.style ? button.style : {}}
  //                 className={`btn btn-giant ${button.className}  ${buttons.length === 1 ? "btn-full" : ""}`}
  //                 onClick={() => button.action()}
  //               >
  //                 {button.name}
  //               </button>
  //             </div>
  //           ))}
  //         </div>
  //       ) : (
  //         <div className="modal-btn-wrap">
  //           <button
  //             className={`btn ${theme ? `btn-${theme}` : "btn-red500"} btn-giant btn-full bold`}
  //             onClick={onClose}
  //           >
  //             확인
  //           </button>
  //         </div>
  //       )}
  //     </div>
  //   </div>
  // );

  const buttonsFinal = buttons
    ? buttons.map((button) => ({
        ...button,
        theme: button?.theme
          ? button.theme
          : button?.className
            ? button.className.split("btn-")[1]
            : "",
      }))
    : undefined;

  return (
    <ModalShared
      modalId={modalId}
      isShow={isShow}
      overlay={overlay}
      overlayValue={overlayValue}
      overlayStyle={overlayStyle}
      theme={theme}
      title={title}
      text={text}
      buttons={buttonsFinal}
      onClose={onClose}
      zIndex={overlayStyle?.zIndex ? Number(overlayStyle.zIndex) + 1 : zIndex}
    />
  );
};

export default Modal;
